import { enUS } from './locales/en-US';
import { idID } from './locales/id-ID';
import { thTH } from './locales/th-TH';
import { viVN } from './locales/vi-VN';
import { zhHantTW } from './locales/zh-hant-TW';

/**
 * Keys match i18n `supportedLngs` with `load: "languageOnly"`.
 */
const resources = {
  en: enUS,
  id: idID,
  th: thTH,
  vi: viVN,
  zh: zhHantTW,
} as const;

export default resources;
